import { ref, computed, watch, unref } from "vue";
import { unrefElement } from "./unrefElement.es.js";
function toValue(r) {
  return typeof r === "function" ? r() : unref(r);
}
function useCssVar(prop, target, options = {}) {
  const { initialValue = "" } = options;
  const variable = ref(initialValue);
  const elRef = computed(() => {
    var _a;
    return unrefElement(target) || ((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
  });
  function updateCssVar() {
    var _a;
    const key = toValue(prop);
    const el = toValue(elRef);
    if (el && window) {
      const value = (_a = window.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
      variable.value = value || initialValue;
    }
  }
  watch([elRef, () => toValue(prop)], updateCssVar, { immediate: true });
  watch(variable, (val) => {
    var _a;
    if ((_a = elRef.value) == null ? void 0 : _a.style)
      elRef.value.style.setProperty(toValue(prop), val);
  });
  return variable;
}
export {
  useCssVar
};
//# sourceMappingURL=useCssVar.es.js.map
